
  import CSVDownload from '@/components/common/download-csv'
  import CareCenterForm from '@/components/carecenter/form'
  import CareCenterEditForm from '@/components/carecenter/edit'
  import CampaignerUserAdd from '@/components/campaigner/addUser'
  import MailChimpMixin from '@/mixins/mailchimp'

  export default {
    mixins: [MailChimpMixin],
    components: {
      'm-csv-btn': CSVDownload,
      'm-campaigner-user-add': CampaignerUserAdd,
      'm-carecenter-form': CareCenterForm,
      'm-carecenter-edit-form': CareCenterEditForm
    },
    data () {
      return {
        form: {},
        menu: false,
        menu2: false,
        time: null,
        date: null,
        dateFormatted: null,
        dialog: false,
        dialog_edit: false,
        search: '',
        pagination: {},
        selectedItem: {},
        visited: false,
        marked: false,
        headers: [
          {
            text: 'ID',
            align: 'left',
            sortable: false,
            value: 'id'
          },
          { text: 'Name', value: 'name' },
          { text: 'Email', value: 'email_address' },
          { text: 'Tel', value: 'tel' },
          { text: 'Address', value: 'fullAddress' },
          { text: 'Visited', value: 'visited' },
          { text: 'Marked', value: 'marked' },
          { text: 'Subscribed', value: 'subscribed_id' }
        ],
        items: []
      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      onSave (data) {
        if (data.address) {
          this.sendForm(data);
          this.dialog = false;
        }
      },
      onClose (data) {
        this.dialog = false;
        this.dialog_edit = false;
        this.reset();
        console.log('close');
      },
      reset () {
        this.form = {};
      },
      onRefresh () {
        this.getDataCenters();
      },
      inValidItem (item) {
        return !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(item.email_address));
      },
      onUpdate (data) {
        console.log('save update carecenter: ' + this.selectedItem.id, data);
        this.updateForm(data);
        this.onClose();
      },
      sendForm (data) {
        // var app = this;
        this.$http
        .post('api/carecenter', data)
        .then(response => {
          console.log('response data', response.data);
          // app.items = response.data;
          this.reset();
          this.getDataCenters();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      updateForm (data) {
        this.updateCarecenter(data);
      },
      updateCarecenter (data, cb) {
        // var app = this;
        var id = this.selectedItem.id;
        console.log('updateForm', data);
        this.$http
        .put('api/carecenter/' + id, data)
        .then(response => {
          console.log('response data', response.data);
          // this.reset();
          if (cb) {
            cb();
          } else {
            this.getDataCenters();
          }
          // app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      editItem (item) {
        this.reset();
        this.selectedItem = this.items.find(i => i === item);
        this.dialog_edit = true;
        console.log('edit', this.selectedItem.id);
      },
      deleteItem (id) {
        this.$http
        .delete('api/carecenter/' + id)
        .then(response => {
          console.log('carecenter deleted', response.data);
          this.getDataCenters();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      getData () {
        this.getDataCenters();
      },
      getDataCenters () {
        var app = this;
        this.$http
        .get('api/carecenter')
        .then(response => {
          console.log('data', response.data);
          app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      subscribe (item) {
        console.log('addSubscriber');
        this.selectedItem = this.items.find(i => i === item);
        this.addSubscriber(item).then((result) => {
          if (result.id) {
            this.updateForm({
              subscribed_id: result.id
            })
          } else {
            console.log('error subscribe: ', result);
          }
        })
      },
      unsubscribe (item) {
        console.log('addSubscriber');
        this.selectedItem = this.items.find(i => i === item);
        this.removeSubscriber(item).then((result) => {
          this.updateForm({
            subscribed_id: null
          })
          console.log('addSubscriber result', result);
        })
      }
    },
    created () {
      this.getData();
    }
  }
